import { request } from '@/shared/api/request'

export const logout = () => {
	return request({ url: 'log_out', method: 'get' })
}
